<div class="dialog-content otp-content">
  <!--title 標題-->
  <h1 class="dialog-title">{{ 'modify-email-dialog.title' | translate }}</h1>
  <div class="dialog-form otp-form">
    <div class="input-block">
      <label class="input-title">{{
        'modify-email-dialog.enter-email' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          matInput
          type="text"
          [formControl]="emailControl"
          [ngClass]="{ 'input-error': showEmailError && emailControl.invalid }"
          [placeholder]="
            'modify-email-dialog.enter-email-placeholder' | translate
          "
        />
        <button
          mat-button
          [disabled]="!isSendOtpAvailable"
          (click)="sendOtp()"
          class="btn-text-primary input-otp-btn"
        >
          {{ 'modify-email-dialog.send-otp' | translate }}
          @if (!isSendOtpAvailable) {
            ({{ otpRemainSeconds }}s)
          }
        </button>
        @if (showEmailError && emailControl.invalid) {
          <mat-error class="input-error-msg">{{
            getEmailErrorMessage()
          }}</mat-error>
        }
      </div>
    </div>

    <div class="input-block">
      <label class="input-title">{{
        'modify-email-dialog.enter-email-otp' | translate
      }}</label>
      <div class="input-group">
        <input
          matInput
          type="text"
          [formControl]="otpControl"
          [ngClass]="{ 'input-error': showOtpError && otpControl.invalid }"
          [placeholder]="
            'modify-email-dialog.enter-email-otp-placeholder' | translate
          "
        />
        @if (showOtpError && otpControl.invalid) {
          <mat-error class="input-error-msg">{{
            getOtpErrorMessage()
          }}</mat-error>
        }
      </div>
      @if (isOtpReachedLimit) {
        <div class="password-change-hint">
          <img
            width="16"
            height="16"
            ngSrc="assets/img/i-warn-outline.svg"
            alt=""
          />
          <span>{{ 'otp-dialog.otp-error-reach-limit' | translate }}</span>
        </div>
      }
    </div>
  </div>
  <div class="dialog-btn-block">
    <button
      mat-button
      class="btn-fill-primary btn-size-l"
      (click)="modifyEmail()"
    >
      {{ 'modify-email-dialog.modify-email' | translate }}
    </button>
    <button
      mat-button
      class="btn-text-underline btn-size-s"
      (click)="closeDialog()"
    >
      {{ 'common.button.cancel' | translate }}
    </button>
  </div>
</div>
